import App from './components/app'
import BootstrapVue from 'bootstrap-vue'
import Vue from 'vue'
import VueCroppie from 'vue-croppie'
import VueRouter from 'vue-router'
import router from './routes'
import store from './store'
import { analytics, analyticsConfig } from './analytics'
import { validation, validationConfig } from './validation'
import { wysiwyg, wysiwygConfig } from './wysiwyg'

const EventBus = new Vue()

Object.defineProperties(Vue.prototype, {
  $bus: {
    get () {
      return EventBus
    }
  }
})

window.Vue = Vue

Vue.use(BootstrapVue)
Vue.use(VueCroppie)
Vue.use(VueRouter)
Vue.use(analytics, analyticsConfig)
Vue.use(validation, validationConfig)
Vue.use(wysiwyg, wysiwygConfig)

// eslint-disable-next-line no-unused-vars
const app = new Vue({
  el: '#app',
  components: { App },
  router,
  store,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/app.js